export default __webpack_public_path__ + "static/media/ico-ads-rent.86eefb31.webp";